/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Page,
  Layout,
  Card,
  TextStyle,
  Icon,
  Stack,
  List,
  Button,
  PageActions,
  Link
} from '@shopify/polaris';
import {
  FilterMajor,
  ColumnWithTextMajor,
  BillingStatementDollarMajor,
  DataVisualizationMajor,
  SettingsMajor,
  DnsSettingsMajor,
  AnalyticsMajor,
  ColorsMajor,
  ListMajor,
  AppsMajor
} from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import MainMenu from 'src/components/containers/main-menu';
import { routes } from 'src/routes';
import { URL } from 'src/constants/links';
import LandingPage from 'src/assets/images/in-app/landing-page.png';

import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

type Props = WithI18nProps;

class NewFeatures extends Component<Props> {
  render() {
    const { i18n, language } = this.props;
    const features = [
      {
        title: i18n.translate('AdminHTML.LandingPage.Common.advancedFilterAndSearch'),
        subFeatures: [
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature1_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature1_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc1}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: FilterMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature2_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature2_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc2}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: ColumnWithTextMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature3_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature1_SubFeature3_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc3}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: BillingStatementDollarMajor
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.LandingPage.Common.analyticsUpdates'),
        subFeatures: [
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature2_SubFeature1_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature2_SubFeature1_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc4}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: AnalyticsMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature2_SubFeature2_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature2_SubFeature2_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc5}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: DataVisualizationMajor
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.LandingPage.Common.newToolSettings'),
        subFeatures: [
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature1_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature1_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc7}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: ColorsMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature2_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature2_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc8}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: ListMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature3_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature4_SubFeature3_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc9}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: AppsMajor
          }
        ]
      },
      {
        title: i18n.translate('AdminHTML.LandingPage.Common.fixesAndImprovements'),
        subFeatures: [
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature1_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature1_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature1_Content_t1'
                        )}
                      </TextStyle>
                    ),
                    t2: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature1_Content_t2'
                        )}
                      </TextStyle>
                    )
                  }
                )}{' '}
              </span>
            ),
            src: SettingsMajor
          },
          {
            title: i18n.translate(
              'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature2_Title'
            ),
            content: (
              <span>
                {i18n.translate(
                  'AdminHTML.LandingPage.2020Q4NewFeatures.feature3_SubFeature2_Content'
                )}{' '}
                <Link external url={URL.LandingPage.Y2020Q4.Doc6}>
                  {i18n.translate('AdminHTML.LandingPage.Common.seeMore')}
                </Link>
              </span>
            ),
            src: DnsSettingsMajor
          }
        ]
      }
    ];

    return (
      <div className="BC-Page BC-Page__Landing-Page">
        <MainMenu />
        <Page title={i18n.translate('AdminHTML.LandingPage.2020Q4NewFeatures.pageTitle')}>
          <Layout>
            <Layout.Section>
              <Stack distribution="equalSpacing">
                <Stack vertical>
                  <Stack.Item>
                    <div className="summary">
                      <p style={{ marginBottom: '1.25rem' }}>
                        {i18n.translate('AdminHTML.LandingPage.2020Q4NewFeatures.paragraph', {
                          t: (
                            <TextStyle variation="strong">
                              {i18n.translate(
                                'AdminHTML.LandingPage.2020Q4NewFeatures.paragraph_t'
                              )}
                            </TextStyle>
                          ),
                          nt_new_line_character: <br />
                        })}
                      </p>

                      <List type="bullet">
                        <List.Item>
                          {i18n.translate('AdminHTML.LandingPage.Common.advancedFilterAndSearch')}
                        </List.Item>
                        <List.Item>
                          {i18n.translate('AdminHTML.LandingPage.Common.analyticsUpdates')}
                        </List.Item>
                        <List.Item>
                          {i18n.translate('AdminHTML.LandingPage.Common.newToolSettings')}
                        </List.Item>
                        <List.Item>
                          {i18n.translate('AdminHTML.LandingPage.Common.fixesAndImprovements')}
                        </List.Item>
                      </List>
                    </div>
                  </Stack.Item>
                  <Stack.Item>
                    <div style={{ marginTop: '0.5rem' }}>
                      <Button primary onClick={this.goToUpgradePage}>
                        {i18n.translate('AdminHTML.LandingPage.2020Q4NewFeatures.buttonChildren')}
                      </Button>
                    </div>
                  </Stack.Item>
                </Stack>
                <img
                  style={
                    language === 'de'
                      ? {
                          height: '12.75rem',
                          width: 'auto',
                          marginTop: '1.5rem',
                          position: 'absolute',
                          left: '36.5625rem'
                        }
                      : { height: '12.75rem', width: 'auto', marginTop: '1.5rem' }
                  }
                  className="BC-Illustration-Image__Dashboard BC-Image__Landing-Page"
                  src={LandingPage}
                  alt={i18n.translate('AdminHTML.LandingPage.2020Q4NewFeatures.imgAlt')}
                />
              </Stack>
            </Layout.Section>

            {features.map((feature, featureIndex) => (
              <Layout.Section key={featureIndex}>
                <Card title={feature.title}>
                  <div className="feature" key={'features-' + featureIndex}>
                    <Layout>
                      {feature.subFeatures.map((sub, subFeatureIndex) => {
                        // Calculate feature index
                        return (
                          <Layout.Section key={subFeatureIndex} oneHalf>
                            <div className="featureBox" key={'features-' + subFeatureIndex}>
                              <div className="featureIconImg">
                                <Icon source={sub.src} color="primary" />
                              </div>
                              <div className="featureContent">
                                <span className="Polaris-Heading">
                                  <TextStyle variation="strong">{sub.title}</TextStyle>
                                </span>
                                <div style={{ marginTop: '6px' }}>{sub.content}</div>
                              </div>
                            </div>
                          </Layout.Section>
                        );
                      })}
                      {feature.subFeatures.length % 2 === 1 && <Layout.Section oneHalf />}
                    </Layout>
                  </div>
                </Card>
              </Layout.Section>
            ))}
          </Layout>
          <PageActions
            primaryAction={{
              content: i18n.translate('AdminHTML.LandingPage.2020Q4NewFeatures.buttonChildren'),
              onAction: this.goToUpgradePage
            }}
          />
        </Page>
      </div>
    );
  }

  // Go to upgrade page
  goToUpgradePage = () => {
    const { history } = this.props;

    history.push(routes.themeUpgrade.view());
  };
}

const mapStateToProps = (state, props) => ({
  language: _.get(state.oauth, 'tenantApp.appLanguage', APP_LANGUAGE_ENGLISH_VALUE)
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(NewFeatures));
